exports.isValid = function (p12830) {
  return !isNaN(p12830) && p12830 >= 1 && p12830 <= 40;
};